module.exports = __webpack_public_path__ + "static/img/china.af0da74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/china.png
// module id = YgRx
// module chunks = 2